import React from 'react';
import { motion } from 'framer-motion';
import ParallaxHero from '../../components/ui/ParallaxHero';
import Section from '../../components/ui/Section';
import Button from '../../components/ui/Button';
import SafeIcon from '../../common/SafeIcon';

const ProgramDetail = ({ title, tag, isReversed, image, features, price }) => (
  <div className={`flex flex-col ${isReversed ? 'md:flex-row-reverse' : 'md:flex-row'} gap-16 items-center my-32`}>
    <div className="flex-1 w-full group relative">
      <div className="absolute -inset-1 opacity-0 group-hover:opacity-100 transition-opacity duration-1000 rounded-sm pointer-events-none"
        style={{ background: 'linear-gradient(135deg, rgba(212,175,55,0.2), transparent)', filter: 'blur(1px)' }} />
      <div className="relative aspect-[3/4] md:aspect-square overflow-hidden rounded-sm border border-white/10">
        <img src={image} alt={title} className="w-full h-full object-cover object-top opacity-75 group-hover:opacity-100 group-hover:scale-105 transition-all duration-1000" />
      </div>
    </div>
    <div className="flex-1 w-full">
      <span className="text-gold tracking-widest uppercase text-sm font-semibold">{tag}</span>
      <h2 className="text-4xl md:text-5xl font-serif text-cream mt-4 mb-6">{title}</h2>
      <p className="text-cream/70 font-light text-lg mb-8 leading-relaxed">
        Ein tiefgreifendes 6-Monats-Transformationsprogramm. Wir sprengen alte Paradigmen, heilen innere Wunden und etablieren eine neue Identität basierend auf Leichtigkeit und Fülle.
      </p>
      <ul className="space-y-4 mb-10">
        {features.map((feat, idx) => (
          <motion.li key={idx} initial={{ opacity: 0, x: -15 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ delay: idx * 0.1 }}
            className="flex items-start gap-4 text-cream/80">
            <SafeIcon name="CheckCircle" className="text-gold mt-1 shrink-0" style={{ filter: 'drop-shadow(0 0 6px rgba(212,175,55,0.6))' }} />
            <span>{feat}</span>
          </motion.li>
        ))}
      </ul>
      <div className="flex items-center gap-8 border-t border-white/10 pt-8 mt-8">
        <div>
          <p className="text-sm text-cream/50 uppercase tracking-widest mb-1">Investment ab</p>
          <p className="text-3xl font-serif text-cream">{price} €</p>
        </div>
        <Button variant="wine">Bewerben</Button>
      </div>
    </div>
  </div>
);

const Programs = () => (
  <div>
    <ParallaxHero
      image="https://media-manager-c.questera.ai/greta-media/8c84f85263efda659889de32f1f32e795be69e9a2504f254db44deecf03d5d2eaf8d8138b6c4ad97d7d004f4d5618742/images/aW1hZ2UvcG5n/5e962f4e81ed25550f0f4cdc2d6861b4.png"
      tag="High-End Coaching"
      title="Deine Mastery. Dein Weg."
      titleHighlight="Mastery."
      subtitle="Tiefgreifende Programme für Frauen, die bereit sind, in allen Lebensbereichen aufzusteigen."
    />
    <Section>
      <ProgramDetail
        title="The Love Code" tag="Beziehungs-Mastery"
        image="https://media-manager-c.questera.ai/greta-media/8c84f85263efda659889de32f1f32e795be69e9a2504f254db44deecf03d5d2eaf8d8138b6c4ad97d7d004f4d5618742/images/aW1hZ2UvcG5n/0a8dbd1ab6196d088ee699a1d0e6492e.png"
        price="3.500"
        features={['Lösung von emotionaler Abhängigkeit & toxischen Mustern', 'Deep Dive: Dualseelen Dynamiken verstehen und heilen', 'Inneres Kind Healing für Urvertrauen', 'Magnetische Ausstrahlung kultivieren']}
      />
      <div className="w-full h-[1px] my-10" style={{ background: 'linear-gradient(to right, transparent, rgba(212,175,55,0.4), transparent)' }} />
      <ProgramDetail
        title="The Business Code" tag="Female Leadership" isReversed
        image="https://media-manager-c.questera.ai/greta-media/8c84f85263efda659889de32f1f32e795be69e9a2504f254db44deecf03d5d2eaf8d8138b6c4ad97d7d004f4d5618742/images/aW1hZ2UvcG5n/c8e44d59a4e812fc499ebd3f1cc275f0.png"
        price="5.000"
        features={['Impostor-Syndrom heilen und wahren Selbstwert erkennen', 'Business-Aufbau aus der weiblichen Intuition (Anti-Hustle)', 'Energetische Blockaden in Bezug auf Geld & Erfolg lösen', 'Innere Souveränität als Leaderin etablieren']}
      />
    </Section>
  </div>
);

export default Programs;